import { MvnCodeFE } from "./const";
import { MvnCodeInitiate } from "../lib/const";

export const STUDY_CAPTURE_STATUS_LANG: {
  CAPTURE_STATUS_BY_CRF_LIST_DOWNLOAD_FAIL: MvnCodeFE;
  CAPTURE_STATUS_BY_VISIT_LIST_DOWNLOAD_FAIL: MvnCodeFE;
  CAPTURE_STATUS_BY_SUBJECT_LIST_DOWNLOAD_FAIL: MvnCodeFE;
  CAPTURE_STATUS_BY_SITE_LIST_DOWNLOAD_FAIL: MvnCodeFE;
} = {
  CAPTURE_STATUS_BY_CRF_LIST_DOWNLOAD_FAIL: {
    ko: "CRF 페이지 별 상태 목록 다운로드에 실패했습니다. ({message})",
    en: "CRFs status by CRF list download has been failed. ({message})",
  },
  CAPTURE_STATUS_BY_VISIT_LIST_DOWNLOAD_FAIL: {
    ko: "Visit 별 CRF 상태 목록 다운로드에 실패했습니다. ({message})",
    en: "CRFs status by Visit list download has been failed. ({message})",
  },
  CAPTURE_STATUS_BY_SUBJECT_LIST_DOWNLOAD_FAIL: {
    ko: "대상자 별 CRF 상태 목록 다운로드에 실패했습니다. ({message})",
    en: "CRFs status by Subject list download has been failed. ({message})",
  },
  CAPTURE_STATUS_BY_SITE_LIST_DOWNLOAD_FAIL: {
    ko: "기관별 CRF 상태 목록 다운로드에 실패했습니다. ({message})",
    en: "CRFs status by Site list download has been failed. ({message})",
  },
};

MvnCodeInitiate(STUDY_CAPTURE_STATUS_LANG);
